import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [NavigationBarComponent, RouterModule],
  templateUrl: 'app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'homes';
  isBrowser: boolean;
  isLoggedIn = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: AuthService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      const token = this.authService.getGoogleToken();
      this.isLoggedIn = !!token;

      // Optional: Handle token refresh from URL code param
      const authCode = this.authService.getAuthorizationCode();
      if (authCode) {
        this.authService.setAuthorizationCode(authCode);
        this.authService.handleLogin(); // Complete Google login
      }
    }
  }

  logout(): void {
    this.authService.logout();
    this.isLoggedIn = false;
  }
}
